import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "upload_push_body"
};
const _hoisted_2 = {
  class: "navbat"
};
const _hoisted_3 = {
  class: "upload_push_body_nr"
};
const _hoisted_4 = {
  class: "clock_task"
};
const _hoisted_5 = {
  style: {
    "width": "100%",
    "font-size": "30px"
  }
};
const _hoisted_6 = {
  key: 0,
  style: {
    "width": "100%",
    "margin-top": "20px",
    "font-size": "25px"
  }
};
const _hoisted_7 = {
  style: {
    "width": "100%",
    "margin-top": "20px",
    "border-radius": "15px",
    "overflow": "hidden"
  }
};
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  key: 0,
  class: "clock_task"
};
const _hoisted_11 = {
  class: "clock_task_top"
};
const _hoisted_12 = {
  style: {
    "display": "flex",
    "font-size": "30px"
  }
};
const _hoisted_13 = {
  class: "clock_task_nr"
};
const _hoisted_14 = {
  key: 0,
  class: "clock_task_nr_text"
};
const _hoisted_15 = {
  style: {
    "flex": "1"
  }
};
const _hoisted_16 = {
  key: 1,
  class: "push_btn"
};
const _hoisted_17 = {
  key: 1,
  class: "cg",
  style: {
    "margin-right": "20px",
    "position": "relative"
  }
};
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  key: 3,
  style: {
    "position": "relative"
  },
  class: "cg"
};
const _hoisted_20 = {
  key: 2,
  style: {
    "font-size": "30px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_van_uploader = _resolveComponent("van-uploader");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/fh.png",
    alt: "",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.fh && $setup.fh(...args))
  }), _cache[7] || (_cache[7] = _createElementVNode("span", null, "肌功能训练课程", -1)), _createElementVNode("span", {
    class: "history",
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.history && $setup.history(...args))
  }, "历史记录")]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, "观看训练" + _toDisplayString($setup.hd_data.type == 'video/mp4' ? '视频' : '图片'), 1)]), $setup.hd_data.type == 'video/mp4' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("span", null, _toDisplayString($setup.hd_data.videoExplain), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [$setup.hd_data.type == 'video/mp4' ? (_openBlock(), _createElementBlock("video", {
    key: 0,
    style: {
      "width": "100%",
      "height": "100%"
    },
    controls: "",
    muted: "",
    loop: "",
    src: $setup.hd_data.url
  }, null, 8, _hoisted_8)) : (_openBlock(), _createElementBlock("img", {
    key: 1,
    src: $setup.hd_data.url,
    style: {
      "width": "100%"
    },
    alt: ""
  }, null, 8, _hoisted_9))])]), $setup.hd_data.statusStr != '已完成' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("span", null, _toDisplayString($setup.hd_data.uploadFlow != 0 ? '请上传训练成果' : '说明'), 1)])]), _createElementVNode("div", _hoisted_13, [$setup.hd_data.uploadFlow != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_cache[8] || (_cache[8] = _createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/img/member_clock/bz.png",
    alt: ""
  }, null, -1)), _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_input, {
    modelValue: $setup.push_data.textarea,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.push_data.textarea = $event),
    rows: 5,
    type: "textarea",
    placeholder: "备注"
  }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true), $setup.hd_data.uploadFlow != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_16, [!$setup.push_data.img ? (_openBlock(), _createBlock(_component_van_uploader, {
    key: 0,
    "after-read": $setup.afterReadImg,
    accept: "image/*"
  }, {
    default: _withCtx(() => _cache[9] || (_cache[9] = [_createElementVNode("img", {
      src: "https://www.mimodental.com/assets/imgData/img/member_clock/push_img.png",
      alt: ""
    }, null, -1)])),
    _: 1,
    __: [9]
  }, 8, ["after-read"])) : (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("img", {
    src: $setup.push_data.img,
    alt: ""
  }, null, 8, _hoisted_18), _createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/delete.png",
    class: "delete_icon",
    onClick: _cache[3] || (_cache[3] = $event => $setup.delete_click('img')),
    alt: ""
  })])), !$setup.push_data.vido ? (_openBlock(), _createBlock(_component_van_uploader, {
    key: 2,
    "after-read": $setup.afterReadVido,
    accept: "video/*"
  }, {
    default: _withCtx(() => _cache[10] || (_cache[10] = [_createElementVNode("img", {
      src: "https://www.mimodental.com/assets/imgData/img/member_clock/push_vido.png",
      alt: ""
    }, null, -1)])),
    _: 1,
    __: [10]
  }, 8, ["after-read"])) : (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/vido_icon.png",
    alt: "",
    onClick: _cache[4] || (_cache[4] = (...args) => $setup.look && $setup.look(...args))
  }), _createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/delete.png",
    class: "delete_icon",
    onClick: _cache[5] || (_cache[5] = $event => $setup.delete_click('vido')),
    alt: ""
  })]))])) : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString($setup.hd_data.videoExplain), 1))])])) : _createCommentVNode("", true)]), $setup.hd_data.statusStr != '已完成' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "clock_task_top_btn",
    onClick: _cache[6] || (_cache[6] = (...args) => $setup.tj && $setup.tj(...args))
  }, " 提交 ")) : _createCommentVNode("", true)]);
}